import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, FlexBox } from '@dixa/lib-shared-habla';
import { memo, useMemo } from 'react';
import { useAppSelector } from 'utils/redux/useAppSelector';
export const MessagingQueueDetails = memo(function MessagingQueueDetails({ queueId, }) {
    const queues = useAppSelector((state) => state.settings.queues.queues);
    const queue = useMemo(() => queues.find((queue) => queue.id === queueId), [queueId, queues]);
    if (queue) {
        return (_jsxs(FlexBox, Object.assign({ gap: "100", alignItems: "center" }, { children: [_jsx("p", { children: queue.name }), queue.is_archived && (_jsx(Badge, Object.assign({ variant: "error", size: "small" }, { children: "Archived" })))] })));
    }
    return _jsx("p", { children: "Loading..." });
});
